import { useExpenseAttachments } from '../../services/api/attachments';
import { Button, GlassPanel, LoadingSpinner } from '../ui';
import { ExpenseAttachmentMultiPagePreview } from './ExpenseAttachmentMultiPagePreview';

/** Uses the canonical active-attachment endpoint, independently of OCR results. */
export function ExpenseOriginalPanel({
  expenseId,
  testid = 'expense-original',
}: {
  expenseId: string;
  testid?: string;
}) {
  const attachments = useExpenseAttachments(expenseId);
  return (
    <GlassPanel className="min-w-0" data-testid={testid}>
      <h2 className="mb-3 text-lg text-white">Originale</h2>
      {attachments.isLoading ? (
        <LoadingSpinner />
      ) : attachments.error ? (
        <div role="alert" className="space-y-2 text-sm text-white/70">
          <p>Die Originale konnten nicht geladen werden.</p>
          <Button variant="ghost" onClick={() => void attachments.refetch()}>
            Erneut laden
          </Button>
        </div>
      ) : (
        <ExpenseAttachmentMultiPagePreview
          attachments={attachments.data?.items ?? []}
          heightClass="h-[50vh] lg:h-[70vh]"
          testid={`${testid}-attachments`}
          enableKeyboard={false}
        />
      )}
    </GlassPanel>
  );
}
